import { Theme } from '@material-ui/core';
import { makeStyles, styled } from '@material-ui/styles';
import React from 'react';

import { RoomType } from '../../../../Models/IRoom';
import { IRoomItem } from '../../../../Models/IRoomItem';
import { RoomMove } from '../../../../Utils/Room/RoomMove';
import { RoomItemDefaultColor, RoomItemStrokeColor } from '../../../Widgets/RoomItems/RoomItemIconFactory';
import { useLaizeCalcDialogState } from '../LaizeCalcDialogProvider';

type PlacingRoomItemProps = { item: IRoomItem };
export const MapUIRoomItem = ({ item }: PlacingRoomItemProps) => {
    const { rooms = [] } = useLaizeCalcDialogState();
    const type = rooms.find((r) => r.roomId === item.roomId)?.type!;
    const classes = useStyles({ type });

    return (
        <GroupMovable
            id={RoomMove.roomItemId(item.roomId!)}
            className={RoomMove.class(item.roomId!)}
            pointerEvents="none">
            <Group className={classes.root}>
                <polygon
                    points={item.coordsReal!.map((p) => `${p.x},${p.y}`).join(' ')}
                    strokeWidth={3}
                    strokeDasharray="12 4"
                />
            </Group>
        </GroupMovable>
    );
};

const GroupMovable = styled('g')({});
const Group = styled('g')({ stroke: '#18335e' });

type IStyleProps = { type?: RoomType };
const getFillColor = (props: IStyleProps) => RoomItemDefaultColor[props.type!];
const useStyles = makeStyles<Theme, IStyleProps>({
    root: (props: IStyleProps) => ({
        fill: getFillColor(props),
        stroke: RoomItemStrokeColor[props.type!],
    }),
});
